// $(document).ready(function(){

//   // Product variant price update js start
//   var VariantId ; 
//   var variantIdFind;
//   var variantPriceFind;
//   var variantComPriceFind;
//   var CurrentPrice = $('.product-info__price .price__default .price__current');
//   var CurrentComparePrice = $('.product-info__price .price__default .price__was');
//   $(document).on('click', '.custom-select__listbox .custom-select__option', function(){
    
//     var $currentDropdown = $(this).closest('.option-selector');
//     var isFirstDropdown = $currentDropdown.is($('.option-selector').first());

//      setTimeout(function(){
//        var url = window.location.href;
//        VariantId = new URL(url).searchParams.get("variant");
//        // console.log(VariantId);
       
//        $('.get_variant').each(function(){
//          variantIdFind = $(this).attr('varid');
//          variantPriceFind = $(this).attr('varprice');
//          variantComPriceFind = $(this).attr('varcomprice');
//          // console.log(variantIdFind);
//           if(variantIdFind == VariantId){
//             // console.log(' This is Variant Id' + ' ' + variantIdFind + ' This is Variant Price' + ' ' + variantPriceFind + ' This is Variant Compare' + ' ' + variantComPriceFind);
//             CurrentPrice.text(variantPriceFind);
//             CurrentComparePrice.text(variantComPriceFind);
//           }  
//        });
//      },500);

//   });

  
//   var $wraps = $('.option-selector');
//   if (!$wraps.length) return;

//   var SELECTOR = '.ctm_part_drop.custom-select__option:not(.is-unavailable):not(.is-nonexistent)[data-value]:not([data-value=""])';

//   function autoSelect($wrap) {
//     if (!$wrap || !$wrap.length) return false;

//     var $csEl = $wrap.find('custom-select.ctm_parent_selectere').first();
//     var $listbox = $wrap.find('.custom-select__listbox.ctm_selecter_part').first();
//     if (!$csEl.length || !$listbox.length || typeof $csEl[0].selectOption !== 'function') return false;

//     var $li = $listbox.find(SELECTOR).first();
//     if ($li.length) {
//       $csEl[0].selectOption($li[0]);
//       return true;
//     }
//     return false;
//   }

//   function watchAndSelect($wrap) {
//     if (!$wrap || !$wrap.length) return;
//     if (autoSelect($wrap)) return;

//     var observer = new MutationObserver(function() {
//       if (autoSelect($wrap)) observer.disconnect();
//     });

//     observer.observe($wrap[0], {
//       subtree: true,
//       childList: true,
//       attributes: true
//     });

//     setTimeout(function() {
//       observer.disconnect();
//     }, 3000);
//   }

//   $wraps.each(function(idx, wrap) {
//     var $wrap = $(wrap);
//     var $csEl = $wrap.find('custom-select.ctm_parent_selectere').first();
//     var $listbox = $wrap.find('.custom-select__listbox.ctm_selecter_part').first();

//     if (!$csEl.length || !$listbox.length) return;

//     $listbox.on('click', '.custom-select__option', function() {
//       var $nextWrap = $wraps.eq(idx + 1);
//       if ($nextWrap.length) {
//         setTimeout(function() {
//           watchAndSelect($nextWrap);
//         }, 50);
//       }
//     });

//     var observer = new MutationObserver(function(mutations) {
//       mutations.forEach(function(m) {
//         if (
//           $(m.target).hasClass("is-selected") ||
//           $(m.target).attr("aria-selected") === "true"
//         ) {
//           var $nextWrap = $wraps.eq(idx + 1);
//           if ($nextWrap.length) {
//             setTimeout(function() {
//               watchAndSelect($nextWrap);
//             }, 50);
//           }
//         }
//       });
//     });

//     observer.observe($listbox[0], {
//       subtree: true,
//       attributes: true,
//       attributeFilter: ["class", "aria-selected"]
//     });
//   });
//   // Product variant price update js end

// });


$(document).ready(function(){

  var CurrentPrice = $('.product-info__price .price__default .price__current');
  var CurrentComparePrice = $('.product-info__price .price__default .price__was');

  var $wraps = $('.option-selector');
  if (!$wraps.length) return;

  var SELECTOR = '.ctm_part_drop.custom-select__option:not(.is-unavailable):not(.is-nonexistent)[data-value]:not([data-value=""])';

  $(document).on('click', '.custom-select__listbox .custom-select__option', function(){
    var $currentWrap = $(this).closest('.option-selector');
    var idx = $wraps.index($currentWrap);

    // --- Price Update ---
    setTimeout(function(){
      var url = window.location.href;
      var VariantId = new URL(url).searchParams.get("variant");

      $('.get_variant').each(function(){
        if($(this).attr('varid') == VariantId){
          CurrentPrice.text($(this).attr('varprice'));
          CurrentComparePrice.text($(this).attr('varcomprice'));
        }
      });
    },300);

    // $wraps.each(function(index) {
    //   if (index <= idx) return;

    //   setTimeout(function() {
    //     var $wrap = $wraps.eq(index);
    //     var $customSelect = $wrap.find('custom-select.ctm_parent_selectere, custom-select').first();
    //     var $listbox = $wrap.find('.custom-select__listbox.ctm_selecter_part, .custom-select__listbox').first();
    //     var $options = $listbox.find('.custom-select__option');
    //     var $available = $options.not('.is-unavailable');
    //     var isLast = (index === $wraps.length - 1);

    //     if (!$customSelect.length || !$listbox.length || typeof $customSelect[0].selectOption !== 'function') return;

    //     if ($available.length) {
    //       $options.hide();   
    //       $available.show(); 
    //     } else {
    //       if (isLast) {
    //         $options.show().css({ opacity: 0.5, "pointer-events": "none" });
    //       } else {
    //         $options.hide();
    //       }
    //     }

    //     var $first = $available.first();
    //     if ($first.length) {
    //       $customSelect[0].selectOption($first[0]);
    //     }

    //   }, 300 * (index - idx)); 
    // });

     $wraps.each(function(index) {
      if (index <= idx) return;

      setTimeout(function() {
        var $wrap = $wraps.eq(index);
        var $customSelect = $wrap.find('custom-select.ctm_parent_selectere, custom-select').first();
        var $listbox = $wrap.find('.custom-select__listbox.ctm_selecter_part, .custom-select__listbox').first();
        var $options = $listbox.find('.custom-select__option');
        var $available = $options.not('.is-unavailable');
        var isLast = (index === $wraps.length - 1);

        if (!$customSelect.length || !$listbox.length || typeof $customSelect[0].selectOption !== 'function') return;

        // --- Load vs Change Logic ---
        if (idx === -1) {
          // Page load case → sab options show (sold-out bhi)
          $options.show();
        } else {
          // Change case → sab options show, auto-select sirf available se
          $options.show();

          var $first = $available.first();
          if ($first.length) {
            $customSelect[0].selectOption($first[0]);
          } else if (isLast) {
            // Agar koi available nahi hai aur ye last dropdown hai → disable karo
            $options.css({ opacity: 0.5, "pointer-events": "none" });
          }
        }

      }, 300 * (index - idx));
    });


  });

});


(function () {
  if (window.innerWidth > 600) return

  function loadjQuery(callback) {
    if (window.jQuery) return callback();
    const script = document.createElement('script');
    script.src = 'https://code.jquery.com/jquery-3.6.0.min.js';
    script.onload = callback;
    document.head.appendChild(script);
  }

  const originalAttachShadow = Element.prototype.attachShadow;
  Element.prototype.attachShadow = function (init) {
    const shadowRoot = originalAttachShadow.call(this, init);
    this._shadowRoot = shadowRoot;
    return shadowRoot;
  };

  function applyMobileStyles() {
    const host = document.querySelector('shopify-accelerated-checkout-cart');
    if (!host || !host._shadowRoot) {
      return setTimeout(applyMobileStyles, 500);
    }

    const $target = $(host._shadowRoot).find('.wallet-cart-grid');
    if ($target.length) {
      $target.css({ 
        'flex-direction': 'row',
        'gap': '10px',
        'align-items': 'center'
      });
    } 
  }

  window.addEventListener('DOMContentLoaded', () => {
    loadjQuery(() => setTimeout(applyMobileStyles, 300));
  });
})();